var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('div',[_c('img',{attrs:{"height":"16","src":"/assets/images/telegram.png","alt":""}})]):_c('div',[_c('i',{staticClass:"fas fa-times default-null-html"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }